import moment from 'moment';
const state = {
    PaymentVoucherItems: {
        data: [],
        total: 0,
    },
    Item: {},
    loadings: {
        list_invoice: false,
        detail: false
    },
    payment: {
        id: '',
        pv_number: '',
        pv_date: null,
        pay_to_id: '',
        get_pay_to: '',
        created_by: '',
        get_created_by: '',
        created_on: '',
        status: '',
        payment_mode: '',
        remark: '',
        creditor_code: '',
        supplier_name: '',
        billing_address: '',
        amount: '',
        gst: '',
        total: '',
        get_pv_line_items: [],
        pv_line_items: [],
        pv_line_items_delete: [],
        ap_invoice_ids: [],
        attachments: []
    },
    lineItems: {
        data: [],
        total: 0
    }
};

const getters = {
    PaymentVoucherItems: (state) => state.PaymentVoucherItems,
    Payment: (state) => state.payment,
    Loading: (state) => state.loadings,
    Item: (state) => state.Item,
};


const actions = {
    async getPaymentVouchers({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/offsets`, { params: params })
                .then(response => {
                    commit('setPaymentVouchers', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deletePaymentVoucher({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/offsets`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async getPayment({ commit }, params) {
        commit('setLoadings', { key: "detail", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/${params}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setItem', response.data.data);
                    commit('setPayment', response.data.data);
                    commit('setLoadings', { key: "detail", val: false });
                    resolve(response);
                })
                .catch(error => {
                    commit('setLoadings', { key: "detail", val: false });
                    reject(error)
                });
        });
    },
    async createPayment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async updatePayment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/${params.id}`, {
                    method: "PUT",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setPayment', response.data.data);
                    commit('setItem', response.data.data);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getInvoices({ commit }, params) {
        commit('setLoadings', { key: "list_invoice", val: true });
        return new Promise((resolve, reject) => {
            global.axios(`api/ap-invoice`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list_invoice", val: false });
                    resolve(response);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list_invoice", val: false });
                    reject(error)
                });
        });
    },

    async createLineItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/line-items`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getLineItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/line-items`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setLineItem', response.data.data.items);
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLineItem', []);
                    reject(error)
                });
        });
    },
    async deleteLineItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/offsets/line-items`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },

    async getApprovalRoute({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/approval-route`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    async getApprovalLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/approval-logs`, {
                    method: "GET",
                    params: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    async createApprovalLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/approval-logs`, {
                    method: "POST",
                    data: params,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    commit('setItem', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },

    async printPayment({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/offsets/generate-pdf/${params}`, {
                    method: "GET",
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error)
                });
        });
    },
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/offsets/export`, { params: params, responseType: 'blob' })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

const mutations = {
    setPaymentVouchers(state, data) {
        state.PaymentVoucherItems = data;
    },
    setItem(state, data) {
        state.Item = data;
    },
    setLineItem(state, data) {
        state.lineItems = data;
    },
    setPayment(state, data) {
        if (data) {
            data.pv_date = data.pv_date ? new Date(moment(data.pv_date, "YYYY-MM-DD").toISOString()) : null;
            data.cheque_date = data.cheque_date ? new Date(moment(data.cheque_date, "YYYY-MM-DD").toISOString()) : null;
            data.ap_invoice_ids = [];
            data.pv_line_items = [];
            data.pv_line_items_delete = [];
            if (data.get_pv_line_items && data.get_pv_line_items.length > 0) {
                let arr = data.get_pv_line_items.map(item => {
                    data.pv_line_items.push(item.ap_invoice);
                    return item.ap_invoice_id;
                });
                data.ap_invoice_ids = arr.length > 0 ? arr : [];
            }
            state.payment = data;
            return
        }
        state.payment = {
            id: '',
            pv_number: '',
            pv_date: null,
            pay_to_id: '',
            get_pay_to: '',
            created_by: '',
            get_created_by: '',
            created_on: new Date(),
            status: '',
            payment_mode: '',
            remark: '',
            creditor_code: '',
            supplier_name: '',
            billing_address: '',
            amount: '',
            gst: '',
            total: '',
            get_pv_line_items: [],
            pv_line_items: [],
            pv_line_items_delete: [],
            ap_invoice_ids: []
        }
    },
    setLoadings(state, data) {
        state.loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}